import { getTracksByIds, getRawTracksByIds } from "./get-by-ids";
export var getTrackById = function (id) {
    return getTracksByIds([id]).then(function (tracks) { return tracks[0]; });
};
export var getRawTrackById = function (id) {
    return getRawTracksByIds([id]).then(function (tracks) { return tracks[0]; });
};
